import React, { useEffect, useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import api from "@/lib/api";
import { PageHeader, EmptyState, Money } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";

export default function AdminProducts() {
  const [products, setProducts] = useState([]);
  const load = () => api.get("/products").then(({ data }) => setProducts(data));
  useEffect(() => { load(); }, []);
  const del = async (id) => { if (window.confirm("Delete product?")) { await api.delete(`/products/${id}`); toast.success("Deleted"); load(); } };
  return (
    <div data-testid="admin-products">
      <PageHeader title="Store Products" subtitle="Manage VIRIKS Store inventory" action={<NewProduct onDone={load} />} />
      {products.length === 0 ? <EmptyState icon={Plus} title="No products" /> : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {products.map((p) => (
            <div key={p.id} className="bg-white border border-border rounded-lg overflow-hidden" data-testid={`ap-${p.id}`}>
              <img src={p.images?.[0]} alt="" className="w-full aspect-video object-cover" />
              <div className="p-4">
                <h3 className="font-semibold text-navy text-sm line-clamp-1">{p.name}</h3>
                <div className="flex items-center justify-between mt-2">
                  <Money amount={p.discount_price || p.price} className="font-bold" />
                  <div className="flex items-center gap-2"><span className="text-xs text-muted-foreground">Stock: {p.stock}</span><button onClick={() => del(p.id)} className="text-crimson"><Trash2 size={15} /></button></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function NewProduct({ onDone }) {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ name: "", description: "", category: "Books", price: "", discount_price: "", stock: "100", images: "https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?w=600" });
  const set = (k, v) => setF((p) => ({ ...p, [k]: v }));
  const create = async () => {
    if (!f.name) return toast.error("Enter name");
    await api.post("/products", { ...f, images: [f.images] }); toast.success("Product added"); setOpen(false); onDone();
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild><Button className="viriks-navy text-white" data-testid="new-product-btn"><Plus size={16} className="mr-1" /> Add Product</Button></DialogTrigger>
      <DialogContent className="max-w-md max-h-[90vh] overflow-auto">
        <DialogHeader><DialogTitle>Add Product</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div><Label>Name</Label><Input value={f.name} onChange={(e) => set("name", e.target.value)} data-testid="np-name" /></div>
          <div><Label>Description</Label><Textarea value={f.description} onChange={(e) => set("description", e.target.value)} /></div>
          <div><Label>Image URL</Label><Input value={f.images} onChange={(e) => set("images", e.target.value)} /></div>
          <div className="grid grid-cols-3 gap-3">
            <div><Label>Price</Label><Input type="number" value={f.price} onChange={(e) => set("price", e.target.value)} data-testid="np-price" /></div>
            <div><Label>Discount</Label><Input type="number" value={f.discount_price} onChange={(e) => set("discount_price", e.target.value)} /></div>
            <div><Label>Stock</Label><Input type="number" value={f.stock} onChange={(e) => set("stock", e.target.value)} /></div>
          </div>
        </div>
        <DialogFooter><Button className="viriks-navy text-white" onClick={create} data-testid="np-submit">Add</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
